var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/welcome1.50b590d9.png","uri@3x": __webpack_public_path__ + "static/media/welcome1.55bd036d.png","uri@2x": __webpack_public_path__ + "static/media/welcome1.2ab84655.png",
    width: 201,
    height: 201
});